import { render, staticRenderFns } from "./AuthWarning.vue?vue&type=template&id=a199666a&scoped=true&"
import script from "./AuthWarning.vue?vue&type=script&lang=js&"
export * from "./AuthWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a199666a",
  null
  
)

export default component.exports